'use client'

import { useBreakpoint } from '@/utils/responsive'
import { Box, Tab, Tabs } from '@mui/material'
import { useParams, useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'

const tabs = [
  {
    path: 'overview',
    title: 'Overview',
  },
  {
    path: 'admissions',
    title: 'Admissions',
  },
  {
    path: 'curriculum',
    title: 'Curriculum',
  },
  {
    path: 'tuitions',
    title: 'Tuition',
  },
]

const ProgramSectionTabs = () => {
  const isSm = useBreakpoint('sm')
  const router = useRouter()
  const params = useParams()

  // Get the current section from URL params, default to 'overview'
  const currentSection = params?.section || 'overview'
  // Validate that the section exists in tabs, otherwise fallback to 'overview'
  const validSection = tabs.some((tab) => tab.path === currentSection)
    ? currentSection
    : 'overview'

  const [value, setValue] = useState(validSection)

  // Sync tab value when URL section changes (for client-side navigation)
  useEffect(() => {
    setValue(validSection)
  }, [validSection])

  const handleChange = (event, newValue) => {
    setValue(newValue)
    router.push(`/programs/${params.slug}/${newValue}`)
  }

  return (
    <>
      <Box
        className="-full-width"
        sx={{ borderBottom: 1, borderColor: 'rgba(5,174,239,.15)' }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          scrollButtons={isSm ? 'auto' : true}
          variant={isSm ? 'standard' : 'scrollable'}
          allowScrollButtonsMobile
          aria-label="Program section tabs"
          centered={isSm ? true : false}
          className="tw:w-full"
        >
          {tabs?.map((tab, idx) => (
            <Tab
              sx={{
                padding: isSm ? '0 44px' : '0 16px',
              }}
              key={idx}
              value={tab.path}
              label={
                <span
                  dangerouslySetInnerHTML={{
                    __html: tab.title || '',
                  }}
                />
              }
            />
          ))}
        </Tabs>
      </Box>
    </>
  )
}

export default ProgramSectionTabs
